import useSWR, { SWRResponse } from 'swr';

export interface UseGeolocationOptions extends PositionOptions {
  query?: boolean;
}

const DEFAULT_TIMEOUT = 10_000; // 10 seconds

export function useGeolocation({
  query = true,
  ...positionOptions
}: UseGeolocationOptions = {}): SWRResponse<
  GeolocationPosition | null,
  GeolocationPositionError
> {
  const geolocationResponse = useSWR(
    query ? ['geolocation', positionOptions] : false,
    async () => {
      if (typeof window === 'undefined' || !('geolocation' in navigator)) {
        return null;
      }

      return await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos),
          (err) => reject(err),
          {
            ...positionOptions,
            timeout: positionOptions.timeout ?? DEFAULT_TIMEOUT,
          },
        );
      });
    },
    {
      errorRetryCount: 0,
      shouldRetryOnError: false,
      keepPreviousData: true,
    },
  );

  return geolocationResponse;
}
